<template>
  <div :id="selector.split('#')[1]">
    <v-row class="w-full" :class="$vuetify.breakpoint.mobile ? 'h-16' : 'h-32'"></v-row>
    <div
      class="text-center font-weight-medium grey--text text--darken-3 mb-5"
      :class="$vuetify.breakpoint.mobile ? 'text-h5' : 'text-h4'"
    >
      <a
        :href="selector"
        class="text-decoration-none grey--text text--darken-3"
      ></a>
      <slot name="title"></slot>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    selector: {
      type: String,
      default: "#",
    },
  },
};
</script>

<style lang="scss" scoped>
</style>